import React, { useEffect } from 'react';
import {
  Paper
  , Typography
  , List
  , ListItem
  , Accordion
  , AccordionSummary
  , AccordionDetails
  , Badge
  , Chip
} from '@material-ui/core';

import { FaRegUser, FaRegListAlt } from 'react-icons/fa';
import { GrValidate } from 'react-icons/gr';
import { connect, useDispatch, useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import { DaikinFormData } from './formData/DaikinFormData';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { productChoiceStepField } from '../fields/customer/productChoiceField';
import { installationStepField } from '../fields/customer/installationField';
import { quoteSummaryField } from '../fields/customer/quoteSummaryField';

import { productChoiceStepField as productChoiceStepFieldMaster } from '../fields/master/productChoiceField';
import { quoteSummaryField as quoteSummaryFieldMaster } from '../fields/master/quoteSummaryField';

import {
  FieldAttribute
  , FieldConditionAttribute
  , getOptionLabelByValue
} from '../helpers/renderHelper';
import State from '../states/State';
import slice from "../states/drawer/slice";

import { peScrollIntoView } from '../helpers/scrollHelper';
import useStyles from '../styles/styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { formName } from '../thunks/constants';

type PeDetailInfoProps = {
  readonly formValues: DaikinFormData,
};

const useCustomStyles = makeStyles(theme => ({
  PeDetailInfo_control: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignContent: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '10px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '80px',
    },
  },
  PeDetailInfo_text: {
    margin: 0,
    padding: '5px 2px',
    color: '#9F9F9F',
  },
  previewLine: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderTop: '3px solid #F9F9F9',
    '&:nth-first-child': {
      borderTop: 'none',
    },
  },
}));

const PeDetailInfo: React.FC<PeDetailInfoProps> = ({ formValues }) => {
  const classes = useStyles();
  const classesCustom = useCustomStyles();
  const theme = useTheme();
  const state = useSelector((state: State) => {
    const shell = state.shell
    return ({
      shell
    });
  });

  const dispatch = useDispatch();

  const { doneStep, currentStep, steps } = state.shell.step;
  const { isAuth, errorNotifs } = state.shell;
  const hasErrorNotif = errorNotifs && errorNotifs !== 0;
  const [expanded, setExpanded] = React.useState<number | false>(currentStep);

  const handleChange = (step: number) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
    setExpanded(newExpanded ? step : false);
  };

  const handleErrorNotifClick = () => {
    const errorNotif = document.querySelector<HTMLInputElement>('div.MuiFormHelperText-root.Mui-error');
    errorNotif && hasErrorNotif && setTimeout(() => {
      peScrollIntoView('div.MuiFormHelperText-root.Mui-error', 'center');
    }, 200);
  }

  useEffect(() => {
    setExpanded(currentStep);
  }, [currentStep]);

  const renderValue = (name: string, value: string) => {
    // console.log(name, value);
    try {
      let jsonValue = JSON.parse(value);
      let printVal = "";
      // loop through json
      let keys = Object.keys(jsonValue);
      keys.forEach((key: string) => {
        switch (name) {
          case "reason_for_going_solar":
            printVal += jsonValue[key] + '\n';
            break;
          case "formchoice_extra":
            printVal += jsonValue[key]['name'] + ': ' + parseFloat(jsonValue[key]['cost']) + '\n';
            break;
          case "subsidies":
            if (jsonValue[key].isChecked) printVal += jsonValue[key]['name'] + '\n';
            break;
          default:
            return value;
        }
      });
      return printVal;
    } catch (err) {
      return value;
    }
  }
  const isLayout = state.shell.layout;

  const handleClose = () => {
    dispatch(slice.actions.updateDrawer(false));
  };

  const handleView = (node: string) => {
    if (isLayout === 2) {
      handleClose();
    };
    setTimeout(
      function () {
        peScrollIntoView('#node_' + node, 'center');
      }, 100
    );
  };


  const renderFormValue = (items: Array<FieldAttribute>, formValues: any) => {
    return items && items.map((item: FieldAttribute) => {
      var result;
      // Pass the more info component
      if (item.name.indexOf('_moreinfo') !== -1) {
        return false;
      }
      // Pass isAuth
      // if (item.props.isAuth && isAuth !== item.props.isAuth) {
      //   return false;
      // }
      // Main render
      if (formValues && formValues[item.name]) {
        let value = item.props.isMultiple ? formValues[item.name] : item.props.options ? getOptionLabelByValue(item.props.options, formValues[item.name]) : formValues[item.name];
        result = <div key={"bound_" + item.name}>
          <ListItem key={"preview_" + item.name} button className={classesCustom.previewLine} onClick={() => handleView(item.name)}>
            <p className={classesCustom.PeDetailInfo_text}>{item.props.label}</p>
            <p className={classes.value}>{
              renderValue(item.name, value)
            }</p>
          </ListItem>
          {item.condition && item.condition.map((con: FieldConditionAttribute) => {
            if (formValues && typeof formValues[item.name] !== 'undefined' && con.value === formValues[item.name]) {
              return renderFormValue(con.fieldChild, formValues);
            }
            return false;
          })}
        </div>
      }
      return result;
    })
  }

  const renderSwitch = (id: number) => {
    switch (id) {
      case 1:
        return renderFormValue(installationStepField, formValues);
      case 2:
        return isAuth ? renderFormValue(productChoiceStepFieldMaster, formValues) : renderFormValue(productChoiceStepField, formValues);
      case 3:
        return isAuth ? renderFormValue(quoteSummaryFieldMaster, formValues) : renderFormValue(quoteSummaryField, formValues);
      default: break;
    }
  }

  // Client Name
  let clientName = "";
  let customerAdress = "";
  if (formValues?.first_name || formValues?.last_name) {
    clientName = (formValues?.first_name ? formValues?.first_name : '') + ' ' + (formValues?.last_name ? formValues?.last_name : '');
  } else {
    clientName = "(No name)";
  }

  if (formValues?.address && formValues?.locality && formValues?.state && formValues?.zip && formValues?.country_iso2 || formValues?.full_address) {
    customerAdress = `${formValues?.address ? formValues?.address + ',' : ''} 
      ${formValues?.locality ? formValues?.locality : ''} 
      ${formValues?.state ? formValues?.state : ''} 
      ${formValues?.zip ? formValues?.zip + ',' : ''}
      ${formValues?.country_iso2 ? formValues?.country_iso2 : ''}` 
      || `${formValues?.full_address ? formValues?.full_address : ''}`;
  }


  return <div className={classesCustom.PeDetailInfo_control}>
    <Paper elevation={0} className={classes.paper}>
      <div className={classes.customer}>
        <GrValidate className={classes.icon} />
        <Typography 
          style={{ marginRight: 10 }}
          variant="h6" 
          component="p" 
          className={classes.titlePart} 
          noWrap>
            Form Status
        </Typography>
        <Badge badgeContent={errorNotifs} color="error" overlap="rectangular">
          <Chip variant="outlined"
            onClick={handleErrorNotifClick} 
            label={hasErrorNotif ? 'INVALID' : 'VALID'} 
            style={{ 
              color: hasErrorNotif ? theme.palette.error.main : theme.palette.success.main, 
              cursor: 'pointer' 
            }}/>
       </Badge>
      </div>
    </Paper>
    <Paper elevation={0} className={classes.paper}>
      <div className={classes.customer}>
        <FaRegUser className={classes.icon} />
        <Typography variant="h6" component="p" className={classes.titlePart} noWrap>{clientName}</Typography>
      </div>
      {<p className={classesCustom.PeDetailInfo_text}>{customerAdress}</p>}
      {formValues?.phone_number && <p className={classesCustom.PeDetailInfo_text}>{formValues?.phone_number}</p>}
      {formValues?.your_email && <p className={classesCustom.PeDetailInfo_text}>{formValues?.your_email}</p>}
    </Paper>
    <Paper elevation={0} className={classes.paper + ' ' + classes.preview}>
      <div className={classes.customer}>
        <FaRegListAlt className={classes.icon} />
        <Typography variant="h6" component="p" className={classes.titlePart} noWrap>Choice preview</Typography>
      </div>

      {steps.map((item: any) => {
        return item.id < steps.length && <Accordion key={item.id} disabled={item.id > doneStep + 1} expanded={expanded === item.id} onChange={handleChange(item.id)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon fontSize="small" />}
            id={item.name}
          >
            <Typography component="p" className={classes.accordion}>{item.name}</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.nopadding}>
            <List>
              {renderSwitch(item.id)}
            </List>
          </AccordionDetails>
        </Accordion>
      })}
    </Paper>
  </div>
}

export default connect(state => ({
  formValues: getFormValues(formName)(state)
})
)(PeDetailInfo);